import { Injectable, signal } from '@angular/core'
import { AuthSession, createClient, SupabaseClient } from '@supabase/supabase-js'
import { environment } from '../../../../environments/environment'
import { Database } from '../../../shared/types/database.types'
import { from, map, Observable } from 'rxjs'
import { ScheduleRule, ScheduleRuleInsert, ScheduleRuleUpdate } from '../models/schedule-rule.model'

@Injectable({
  providedIn: 'root'
})
export class SupabaseService {
  private supabase: SupabaseClient<Database>
  session = signal<AuthSession | null>(null)

  constructor() {
    this.supabase = createClient<Database>(environment.supabaseUrl, environment.supabaseKey, {
      global: { headers: { 'Access-Control-Allow-Origin': '*' } }
    })
  }

  initSession() {
    this.supabase.auth
      .getSession()
      .then(({ data }) => {
        this.session.set(data.session)
      })
      .catch(error => {
        console.log('error', error)
      })
    this.supabase.auth.onAuthStateChange((_, session) => {
      this.session.set(session)
    })

    return this.supabase.auth.signInWithPassword({
      email: environment.supabaseUserEmail,
      password: environment.supabaseUserPwd
    })
  }

  listScheduleRules(): Observable<ScheduleRule[]> {
    return from(this.supabase.from('schedules_rules').select('*')).pipe(
      map(
        response => response.data?.map(rule => ({ ...rule, weekdays: rule.weekdays || [] })) || []
      )
    )
  }

  updateScheduleRule(
    id: string,
    scheduleRule: ScheduleRuleUpdate
  ): Observable<ScheduleRule | null> {
    return from(
      this.supabase.from('schedules_rules').update(scheduleRule).eq('id', id).select().single()
    ).pipe(map(response => response.data || null))
  }

  getScheduleRuleByShopAndCamera(shopId: string, cameraId: string): Observable<ScheduleRule | null> {
    return from(
      this.supabase
        .from('schedules_rules')
        .select('*')
        .eq('shop_id', shopId)
        .eq('camera_id', cameraId)
        .maybeSingle()
    ).pipe(map(response => (response.data ? { ...response.data, weekdays: response.data.weekdays || [] } : null)))
  }

  updateScheduleRulesFromAdmin(shopId?: string) {
    return from(
      this.supabase.functions.invoke<{ rules: ScheduleRuleInsert[] }>(
        'update-schedule-rules-from-admin',
        {
          body: { shopId }
        }
      )
    ).pipe(map(response => response.data?.rules || []))
  }
}
